import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import {  Button, Card, CardBody, CardHeader } from 'reactstrap'

const propTypes = {
  selectedTemplate: PropTypes.object
}

const defaultProps = {
  selectedTemplate: {}
}

const TEMPLATE_LINK = 'https://drive.google.com/file/d/1ABaFS5fFppboz1bDm7vgderyk_eGUTMa/view?usp=sharing'

const BlastWhatsappInstructionCard = ({ selectedTemplate }) => (
  <Card>
    <CardHeader>
      { 'Blast Notification' }
    </CardHeader>
    <CardBody>
      <p>
        { 'Kamu dapat segera melakukan ' }
        <b>{ 'Blast Notification' }</b>
        { ' pada template ' }
        <b>{ selectedTemplate.name }</b>
        { ' setelah:' }
        <ul>
          <li>
            { 'Memastikan template yang akan digunakan telah ' }
            <strong>{ 'diapproved ' }</strong>
            { ' oleh pihak twilio.' }
          </li>
          <li>
            { 'Menyiapkan CSV yang berisi daftar ' }
            <strong>{ 'ID' }</strong>
            { ' user/seller/customer yang akan menerima pesan.' }
          </li>
          <li>
            { 'Contoh format CSV dapat dilihat pada link ' }
            <strong>
              <a
                href={ TEMPLATE_LINK }
                target='_blank'
                rel='noopener noreferrer'
              >
                { 'berikut' }
              </a>
            </strong>
          </li>
        </ul>
        { 'Apabila sudah siap, kamu dapat menekan tombol dibawah ini untuk diarahkan ke halaman ' }
        <b>{ 'Blast Notification' }</b>
      </p>

      <Button
        color='primary'
        tag={ Link }
        block
        to={ `/app/marketing/announcements/template/${selectedTemplate.id}/blast` }
      >
        { 'Blast whatsapp' }
      </Button>

    </CardBody>
  </Card>
)

BlastWhatsappInstructionCard.propTypes    = propTypes
BlastWhatsappInstructionCard.defaultProps = defaultProps

export default BlastWhatsappInstructionCard
